export const siteStats = [
  { value: "128", label: "收录同人作品条目", unit: "篇" },
  { value: "6", label: "画风流派归档", unit: "类" },
  { value: "10", label: "剧情设定分类", unit: "种" },
  { value: "24", label: "常用术语收录", unit: "条" },
];

export const overviewCards = [
  {
    icon: "ri-book-2-line",
    title: "同人漫画导览",
    desc: "按剧情设定与连载状态整理岳母题材同人漫画，提供简介、篇幅与阅读门槛说明，方便快速判断是否对味。",
  },
  {
    icon: "ri-palette-line",
    title: "插画与画风图鉴",
    desc: "把常见画风拆成水彩、水墨、赛璐璐、油画等流派，配关键字与代表特征，帮你在浏览前先锁定审美取向。",
  },
  {
    icon: "ri-stack-line",
    title: "本子与合集推荐",
    desc: "以合集形式呈现人气本子条目，标注画师风格、剧情标签与阅读顺序，避免在一堆同名作品里迷路。",
  },
  {
    icon: "ri-heart-3-line",
    title: "岳母题材解析",
    desc: "从人物弧光与关系张力入手，梳理“女友的妈妈”这一设定为何耐读，常见的情感冲突与走向有哪些。",
  },
];

export const artStyles = [
  {
    id: "watercolor",
    name: "水彩柔光派",
    traits: ["柔边晕染", "低饱和暖调", "氛围留白"],
    desc: "以水彩质感为主，边缘柔和、色调偏暖，擅长表现日常与情绪流动，适合温馨向与细腻情感叙事的作品。",
    img: "https://readdy.ai/api/search-image?query=delicate%20watercolor%20manga%20illustration%20of%20an%20elegant%20mature%20woman%20with%20soft%20flowing%20hair%2C%20warm%20cream%20background%2C%20gentle%20brush%20texture%2C%20tasteful%20calm%20portrait%2C%20muted%20rose%20and%20sage%20palette%2C%20storybook%20art%20style%2C%20high%20detail&width=800&height=1100&seq=gm-style-water-01&orientation=portrait",
  },
  {
    id: "ink",
    name: "水墨写意派",
    traits: ["粗墨线", "留白构图", "东方韵味"],
    desc: "借水墨的枯湿浓淡来塑造轮廓，画面克制、富有张力，多用于气质清冷或年代感较强的设定。",
    img: "https://readdy.ai/api/search-image?query=traditional%20ink%20wash%20manga%20illustration%20of%20a%20graceful%20mature%20woman%2C%20black%20brush%20strokes%20and%20warm%20sepia%20wash%2C%20minimalist%20composition%2C%20elegant%20tasteful%20portrait%2C%20textured%20rice%20paper%20background%2C%20oriental%20art%20style&width=800&height=1100&seq=gm-style-ink-01&orientation=portrait",
  },
  {
    id: "cel",
    name: "赛璐璐动画派",
    traits: ["分明色块", "硬边高光", "镜头感强"],
    desc: "色块干净、线条利落，接近电视动画的观感，适合节奏明快的轻松搞笑或都市轻喜剧。",
    img: "https://readdy.ai/api/search-image?query=clean%20cel%20shaded%20anime%20illustration%20of%20a%20poised%20mature%20woman%2C%20warm%20amber%20and%20cream%20color%20palette%2C%20soft%20blurred%20interior%20background%2C%20tasteful%20elegant%20portrait%2C%20expressive%20eyes%2C%20gentle%20lighting&width=800&height=1100&seq=gm-style-cel-01&orientation=portrait",
  },
  {
    id: "pastel",
    name: "粉彩梦幻派",
    traits: ["梦幻光斑", "低对比", "滤镜质感"],
    desc: "整体笼罩一层柔和光晕，色调梦幻，常用于梦境、回忆与新海诚式氛围的短篇插画。",
    img: "https://readdy.ai/api/search-image?query=soft%20pastel%20digital%20illustration%20of%20an%20elegant%20mature%20woman%2C%20muted%20dusty%20rose%20and%20cream%20tones%2C%20dreamy%20bokeh%20background%2C%20tasteful%20gentle%20portrait%2C%20cozy%20ambient%20lighting%2C%20refined%20art%20style&width=800&height=1100&seq=gm-style-pastel-01&orientation=portrait",
  },
  {
    id: "retro",
    name: "复古老番派",
    traits: ["颗粒纹理", "褪色配色", "年代感"],
    desc: "模仿上世纪末动画的胶片颗粒与褪色色阶，自带怀旧情绪，适合回忆向与年代设定。",
    img: "https://readdy.ai/api/search-image?query=retro%20nineties%20anime%20illustration%20of%20a%20sophisticated%20mature%20woman%2C%20grainy%20vintage%20texture%2C%20warm%20faded%20colors%2C%20tasteful%20portrait%2C%20nostalgic%20aesthetic%2C%20soft%20shading&width=800&height=1100&seq=gm-style-retro-01&orientation=portrait",
  },
  {
    id: "oil",
    name: "厚涂油画派",
    traits: ["笔触厚重", "光影强烈", "质感浓郁"],
    desc: "以厚涂堆叠塑造体积，明暗对比强烈，氛围浓郁，多用于暗黑悬疑或情感冲突强烈的长篇。",
    img: "https://readdy.ai/api/search-image?query=impasto%20oil%20painting%20illustration%20of%20an%20elegant%20mature%20woman%2C%20rich%20warm%20amber%20and%20deep%20rose%20tones%2C%20painterly%20strokes%2C%20tasteful%20classical%20portrait%2C%20textured%20canvas%20background&width=800&height=1100&seq=gm-style-oil-01&orientation=portrait",
  },
];

export const genreTabs = [
  { id: "all", label: "全部" },
  { id: "comedy", label: "轻松搞笑" },
  { id: "daily", label: "温馨日常" },
  { id: "drama", label: "情感纠葛" },
  { id: "dark", label: "暗黑悬疑" },
  { id: "urban", label: "都市写实" },
];

export const works = [
  {
    id: "w1",
    title: "周末的便当",
    author: "雨宫澄",
    genre: "daily",
    genreLabel: "温馨日常",
    chapters: "全 12 话",
    rating: "9.2",
    tags: ["日常", "单亲家庭", "饭菜料理"],
    summary:
      "女友出差后，男主每周替她给独居的母亲送便当。从厨房里的琐碎对话开始，两个人都慢慢习惯了这份被需要的感觉。",
    cover: "https://readdy.ai/api/search-image?query=warm%20everyday%20watercolor%20manga%20cover%20illustration%20of%20a%20mature%20woman%20cooking%20in%20a%20sunlit%20kitchen%2C%20steam%20and%20soft%20light%2C%20tasteful%20calm%20mood%2C%20muted%20cream%20and%20rose%20tones%2C%20storybook%20art%20style&width=800&height=1100&seq=gm-work-cover-01&orientation=portrait",
  },
  {
    id: "w2",
    title: "岳母的秘密社团",
    author: "猫町三丁目",
    genre: "comedy",
    genreLabel: "轻松搞笑",
    chapters: "连载中 · 28 话",
    rating: "8.7",
    tags: ["搞笑", "误会", "社团"],
    summary:
      "男主偶然加入一个社区读书会，才发现会长正是女友平日里最严厉的母亲。为了不穿帮，一场荒诞的双面生活就此展开。",
    cover: "https://readdy.ai/api/search-image?query=bright%20playful%20cel%20shaded%20manga%20cover%20of%20a%20confident%20mature%20woman%20smiling%2C%20warm%20amber%20and%20cream%20palette%2C%20cheerful%20light%20background%2C%20tasteful%20comic%20style%2C%20vivid%20color&width=800&height=1100&seq=gm-work-cover-02&orientation=portrait",
  },
  {
    id: "w3",
    title: "回信的三十天",
    author: "木之下",
    genre: "drama",
    genreLabel: "情感纠葛",
    chapters: "全 30 话",
    rating: "9.5",
    tags: ["书信", "年上", "细腻"],
    summary:
      "一场搬家中发现的旧信，让男主对这位看似平淡的岳母有了全新的认识。三十封信，串起一段被岁月掩埋的选择。",
    cover: "https://readdy.ai/api/search-image?query=thoughtful%20oil%20painting%20manga%20cover%20of%20an%20elegant%20mature%20woman%20reading%20old%20letters%2C%20warm%20dim%20lamp%20light%2C%20deep%20rose%20and%20amber%20tones%2C%20melancholic%20tasteful%20portrait%2C%20textured%20painterly%20style&width=800&height=1100&seq=gm-work-cover-03&orientation=portrait",
  },
  {
    id: "w4",
    title: "雨天的旧公寓",
    author: "夜灯",
    genre: "dark",
    genreLabel: "暗黑悬疑",
    chapters: "全 18 话",
    rating: "8.9",
    tags: ["悬疑", "心理", "雨夜"],
    summary:
      "女友失踪后，男主搬进她母亲独居的旧公寓暂住。雨夜里的脚步声、上锁的房间，以及岳母欲言又止的眼神，都指向一个共同的名字。",
    cover: "https://readdy.ai/api/search-image?query=moody%20ink%20wash%20manga%20cover%20of%20an%20enigmatic%20mature%20woman%20in%20a%20rainy%20dim%20room%2C%20deep%20shadow%20and%20cool%20sepia%2C%20suspenseful%20atmosphere%2C%20tasteful%20elegant%20portrait%2C%20cinematic%20composition&width=800&height=1100&seq=gm-work-cover-04&orientation=portrait",
  },
  {
    id: "w5",
    title: "合租的第 100 天",
    author: "南野澪",
    genre: "urban",
    genreLabel: "都市写实",
    chapters: "连载中 · 41 话",
    rating: "8.4",
    tags: ["都市", "合租", "生活流"],
    summary:
      "因为房租压力，男主和女友的母亲成了同一屋檐下的室友。柴米油盐、加班晚归，成年人的体贴往往藏在不说破的细节里。",
    cover: "https://readdy.ai/api/search-image?query=restrained%20realistic%20digital%20manga%20cover%20of%20a%20composed%20mature%20woman%20in%20a%20city%20apartment%20at%20dusk%2C%20warm%20window%20light%2C%20muted%20earth%20and%20rose%20tones%2C%20tasteful%20slice%20of%20life%20portrait&width=800&height=1100&seq=gm-work-cover-05&orientation=portrait",
  },
  {
    id: "w6",
    title: "妈妈的偶像练习",
    author: "团子屋",
    genre: "comedy",
    genreLabel: "轻松搞笑",
    chapters: "全 15 话",
    rating: "8.1",
    tags: ["搞笑", "追星", "反差萌"],
    summary:
      "为了帮岳母抢演唱会门票，男主被迫成为应援站站主。中年粉丝的战斗力远超他的想象，一场热闹的全民追星喜剧开场。",
    cover: "https://readdy.ai/api/search-image?query=energetic%20pop%20anime%20manga%20cover%20of%20a%20cheerful%20mature%20woman%20holding%20a%20concert%20light%20stick%2C%20colorful%20warm%20palette%2C%20lively%20background%2C%20tasteful%20playful%20comic%20style&width=800&height=1100&seq=gm-work-cover-06&orientation=portrait",
  },
  {
    id: "w7",
    title: "花道教室的午后",
    author: "藤枝",
    genre: "daily",
    genreLabel: "温馨日常",
    chapters: "全 9 话",
    rating: "9.0",
    tags: ["疗愈", "花道", "慢节奏"],
    summary:
      "为了陪女友学花道，男主成了教室里唯一的男学员。插花讲究取舍，而这位老师对待人生的方式，也在悄悄影响着每个学生。",
    cover: "https://readdy.ai/api/search-image?query=serene%20pastel%20manga%20cover%20of%20an%20elegant%20mature%20woman%20arranging%20flowers%20in%20a%20sunlit%20studio%2C%20soft%20dusty%20rose%20and%20sage%20palette%2C%20tranquil%20tasteful%20portrait&width=800&height=1100&seq=gm-work-cover-07&orientation=portrait",
  },
  {
    id: "w8",
    title: "旧照片里没有我",
    author: "白描",
    genre: "drama",
    genreLabel: "情感纠葛",
    chapters: "全 22 话",
    rating: "9.3",
    tags: ["家庭", "真相", "抉择"],
    summary:
      "整理相册时，男主发现女友童年的照片里，从来没有出现父亲的身影。随着岳母的讲述，一段关于失去与坚韧的往事缓缓展开。",
    cover: "https://readdy.ai/api/search-image?query=emotional%20watercolor%20manga%20cover%20of%20a%20mature%20woman%20holding%20an%20old%20photo%20album%2C%20warm%20muted%20amber%20and%20rose%20tones%2C%20gentle%20sad%20tasteful%20portrait%2C%20soft%20brush%20texture&width=800&height=1100&seq=gm-work-cover-08&orientation=portrait",
  },
  {
    id: "w9",
    title: "深夜电台的第 7 位听众",
    author: "回声台",
    genre: "dark",
    genreLabel: "暗黑悬疑",
    chapters: "全 16 话",
    rating: "8.6",
    tags: ["悬疑", "电台", "秘密"],
    summary:
      "一档深夜情感电台，永远只有七位听众。当男主发现第七位匿名来电者的声音与岳母一模一样时，平静的夜晚开始出现裂缝。",
    cover: "https://readdy.ai/api/search-image?query=nocturnal%20ink%20manga%20cover%20of%20a%20mature%20woman%20silhouette%20by%20a%20radio%20in%20a%20dark%20room%2C%20deep%20shadow%20and%20warm%20amber%20accent%20light%2C%20intriguing%20tasteful%20atmosphere&width=800&height=1100&seq=gm-work-cover-09&orientation=portrait",
  },
  {
    id: "w10",
    title: "搬家前的最后一晚",
    author: "柚子町",
    genre: "urban",
    genreLabel: "都市写实",
    chapters: "全 11 话",
    rating: "8.8",
    tags: ["都市", "告别", "成长"],
    summary:
      "女友赴海外工作，男主负责把这间住了多年的老房子清空。最后一场与岳母共同打包的夜晚，让两个人重新理解了“家”的含义。",
    cover: "https://readdy.ai/api/search-image?query=quiet%20realistic%20digital%20manga%20cover%20of%20a%20mature%20woman%20packing%20cardboard%20boxes%20in%20a%20nearly%20empty%20room%2C%20warm%20evening%20light%2C%20muted%20rose%20and%20earth%20tones%2C%20tasteful%20bittersweet%20portrait&width=800&height=1100&seq=gm-work-cover-10&orientation=portrait",
  },
];

export const characters = [
  {
    name: "温柔持家型",
    tag: "高频出场",
    desc: "把关心藏进一顿饭、一件外套里，很少直接表达情绪。她的温柔不是没有边界，而是学会了先照顾别人。",
    conflict: "与男主的张力来自“过度体贴”本身——当照顾变成依赖，谁先开口就成了难题。",
    icon: "ri-heart-2-line",
  },
  {
    name: "强势独立型",
    tag: "冲突引擎",
    desc: "事业与生活都拿得稳，说话直接、界限分明。她从不认为自己需要被照顾，却在意别人是否尊重她的判断。",
    conflict: "她与男主往往从“对立”开始，在一次次势均力敌的交锋里，反而建立了最坦诚的关系。",
    icon: "ri-shield-star-line",
  },
  {
    name: "神秘隐忍型",
    tag: "悬念核心",
    desc: "话不多，眼神和停顿却信息量极大。她的过去像一间上锁的房间，读者会忍不住想知道门后有什么。",
    conflict: "她推动的是悬疑线的推进，与男主的关系建立在“逐步揭开”与“是否值得信任”的拉扯之上。",
    icon: "ri-eye-off-line",
  },
  {
    name: "烟火气生活型",
    tag: "共情担当",
    desc: "会砍价、会抱怨、会为一集电视剧掉眼泪，真实得像住在隔壁。她让“岳母”这个符号重新变回一个具体的人。",
    conflict: "冲突更多来自现实琐事而非戏剧化事件，靠日常细节累积出令人信服的亲近感。",
    icon: "ri-home-smile-line",
  },
];

export const readGuide = [
  {
    step: "01",
    title: "先定口味方向",
    desc: "从“轻松搞笑 / 温馨日常 / 情感纠葛 / 暗黑悬疑 / 都市写实”里挑一个最想看的基调。基调决定了情节节奏和情绪浓度，先选它比先看图更省时间。",
  },
  {
    step: "02",
    title: "再定画风偏好",
    desc: "在画风图鉴里对照六种流派的特征描述，锁定你更能接受的线稿与配色。同一题材下，画风差异带来的观感可能完全不同。",
  },
  {
    step: "03",
    title: "看篇幅与状态",
    desc: "只想快速尝鲜就选 10 话以内的短篇；愿意追更再看“连载中”。标注了章节数与完结状态，避免读一半卡在坑里。",
  },
  {
    step: "04",
    title: "借助合集顺序",
    desc: "同题材作品常有致敬与互文，建议按合集卡片上的推荐顺序阅读，能发现单独看不出来的彩蛋与呼应。",
  },
];

export const glossary = [
  { term: "同人", def: "指基于原作或原创设定进行的非商业二次创作，涵盖漫画、插画、小说等形式。" },
  { term: "本子", def: "圈内对同人志（同人漫画册）的口语称呼，通常由个人或小社团自费出版。" },
  { term: "岳母题材", def: "以“女友或妻子的母亲”为核心角色的创作方向，重点在于年上关系与家庭语境下的情感张力。" },
  { term: "年上", def: "指角色年龄差中较年长的一方，常用于描述成熟女性角色的设定类型。" },
  { term: "设定集", def: "汇总角色设定、场景草图与创作说明的合集，阅读前先看有助于理解世界观。" },
  { term: "短篇 / 一册完结", def: "故事在一册或少量章节内完整收束，适合想要单次读完的读者。" },
  { term: "连载中", def: "作品仍在持续更新，尚未完结，追更时需留意更新节奏。" },
  { term: "致敬", def: "创作者在作品中借用经典桥段或构图向同行致意，阅读时能发现互文乐趣。" },
  { term: "演出", def: "指画面对节奏、镜头与情绪的安排方式，好的演出能显著提升阅读体验。" },
  { term: "分镜", def: "页面中格子的排布与顺序，决定了读者的视线走向与阅读节奏。" },
  { term: "线稿", def: "未上色的纯线条画作，常用于展现画师的基本功与结构理解。" },
  { term: "氛围向", def: "不以强剧情推进为主，重视情绪与画面感受的作品类型。" },
];

export const faqs = [
  {
    q: "这个站点主要收录什么内容？",
    a: "本站以“女友的妈妈”这一同人题材为核心，整理相关的同人漫画条目、插画与画风图鉴、本子与合集推荐，并提供设定分类与阅读指南。所有内容以导览和索引为主，帮助你更快找到想看的方向。",
  },
  {
    q: "页面上的作品信息是真实存在的吗？",
    a: "为便于演示与浏览，列表中的作品名称、作者与简介为示意条目，用于呈现分类与筛选的完整效果。浏览时请以其标签与设定描述作为口味参考，不要将示意条目默认当作已核实的发行信息。",
  },
  {
    q: "怎么快速找到符合自己口味的作品？",
    a: "建议先用作品合集上方的题材标签筛选基调，再到画风图鉴里锁定你偏好的线稿与配色，最后结合篇幅与连载状态决定是否开读。三步基本能筛掉大部分不对味的作品。",
  },
  {
    q: "“轻松搞笑”和“暗黑悬疑”的差别在哪里？",
    a: "两者的差异主要体现在冲突来源与情绪浓度。轻松搞笑依赖误会、反差与日常笑点，读起来轻快；暗黑悬疑则围绕秘密与心理博弈推进，氛围压抑、节奏更慢，适合想沉浸于悬念的读者。",
  },
  {
    q: "作品里的章节数和连载状态准确吗？",
    a: "章节数与状态为示意数据，用于说明筛选维度。实际阅读时请以对应发布方的信息为准，本站仅提供分类参考，不对具体连载进度作保证。",
  },
  {
    q: "如果我喜欢某个画风，怎么找到同类作品？",
    a: "可以在画风图鉴中记下流派名称（如“水彩柔光派”“复古老番派”），再回到作品合集留意卡片上的标签。同一画风的作品常常共享相近的题材与节奏，是扩展阅读的好线索。",
  },
];